<template>
  <el-dialog
    id="modalDocument"
    :visible.sync="showLocal"
    :width="dialogWidth"
    center
  >
    <!-- If content is called -->
    <div
      v-if="content"
      class="defaultCursor"
    >
      <!-- Header -->
      <div class="header">
        <!-- Header-title -->
        <div
          v-if="content.header.title"
          class="title"
        >
          <span>
            {{ content.header.title }}
          </span>
        </div>

        <!-- Header-desc -->
        <div
          v-for="(desc, DKey) in content.header.description"
          :key="`De${DKey}`"
          class="desc"
        >
          <div
            class="descContent"
            :class="desc.type === 'pre' ? 'preText' : ''"
          >
            {{ desc.content }}
          </div>
        </div>

        <!-- Header Media -->
        <div
          v-for="(media, MKey) in content.header.media"
          :key="`Me${MKey}`"
          class="mediaWrap"
        >
          <div v-if="media.type === 'audio'">
            <audio
              controls
              :autoplay="false"
              :src="media.data"
            >
              Your browser does not support the audio file.
            </audio>
          </div>
        </div>
      </div>

      <!-- Body -->
      <div
        class="body"
        :class="content.bodyType"
      >
        <div
          v-for="(body, CKey) in content.bodies"
          :key="`Body${CKey}`"
        >
          <!-- Body-Ul -->
          <div v-if="body.type === 'ul'">
            <ul>
              <li
                v-for="(ul, UKey) in body.list"
                :key="`Ul${UKey}`"
              >
                <b
                  v-if="ul.title"
                  class="listTitle"
                >
                  {{ ul.title }}
                </b>
                <div>
                  {{ ul.content }}
                </div>
              </li>
            </ul>
          </div>

          <!-- Body-Ol -->
          <div v-if="body.type === 'ol'">
            <ol>
              <li
                v-for="(ol, OKey) in body.list"
                :key="`Ol${OKey}`"
              >
                <b
                  v-if="ol.title"
                  class="listTitle"
                >
                  {{ ol.title }}
                </b>
                <div>
                  {{ ol.content }}
                </div>
              </li>
            </ol>
          </div>

          <!-- Body-Text -->
          <div v-if="body.type === 'text'">
            <div
              v-for="(text, TKey) in body.text"
              :key="`Te${TKey}`"
            >
              <b
                v-if="text.title"
                class="textTitle"
              >
                {{ text.title }}
              </b>
              <div
                v-if="text.content"
                class="textBody"
                :class="text.type === 'pre' ? 'preText' : ''"
              >
                {{ text.content }}
              </div>
            </div>
          </div>

          <!-- Body-Circle -->
          <div
            v-else-if="body.type === 'circle'"
            class="circleWrap"
          >
            <div
              v-for="(cir, CiKey) in body.list"
              :key="`Cir${CiKey}`"
              class="circle"
            >
              {{ cir.text }}
            </div>
          </div>

          <!-- Body - Table -->
          <div
            v-else-if="body.type === 'table'"
            class="tableWrap"
          >
            <div class="tableTitle">
              <b>{{ body.title }}</b>
            </div>
            <table class="DocTable">
              <tr>
                <th
                  v-for="(thead, THKey) in body.columns"
                  :key="`Th${THKey}`"
                >
                  {{ thead }}
                </th>
              </tr>
              <tr
                v-for="(trow, TrKey) in body.data"
                :key="`Tr${TrKey}`"
              >
                <td
                  v-for="(tdata, TdKey) in trow"
                  :key="`Td${TdKey}`"
                >
                  {{ tdata }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Replenish -->
      <div
        v-if="content.replenish"
        class="replenish"
      >
        {{ content.replenish }}
      </div>

      <!-- Button Area -->
      <div
        slot="footer"
        class="dialog-footer"
      >
        <div
          class="buttonWarp"
          style="text-align: center; padding: 10px 0 0;"
        >
          <el-button
            v-for="(button, BKey) in content.buttons"
            :key="`Btn${BKey}`"
            :type="button.type"
            round
            @click="buttonBehaviour(button.key)"
          >
            {{ button.title }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- /Content -->
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';
import contents from './data/modalData';

export default {
  mixins: [dialog],

  props: {
    type: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    contents,
  }),

  computed: {
    content() {
      let result;
      if (this.contents && this.type) {
        this.contents.forEach((content) => {
          if (content.type === this.type) {
            result = content;
          }
        });
      }
      return result;
    },
  },

  methods: {
    buttonBehaviour(key) {
      const type = key.split(':');

      if (type[0] === 'route') {
        this.$router.push({
          name: type[1],
        })
          .catch((error) => {
            console.log(error);
          });
      } else if (type[0] === 'close') {
        this.$emit('update:show', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#modalDocument {
  .el-dialog {
    max-width: 95%;
    z-index: 9000;

    .header {
      font-size: 16px;
      word-break: break-word;

      .title {
        font-weight: bold;
        padding: 15px 0;
      }

      .desc {
        line-height: 22px;

        .descContent {
          padding: 10px 0;

          &.preText {
            white-space: pre-line;
          }
        }
      }

      .mediaWrap {
        background-color: #a1a1a1;
        padding: 5px 0;
        text-align: center;
        font-size: 0;

        audio {
          width: calc(80% + 20px);
          max-height: 30px;
        }
      }
    }

    .body {
      background-color: rgba(239, 245, 243, 0.9);
      font-size: 16px;
      margin-top: 20px;
      padding: 10px 0;
      box-sizing: border-box;
      word-break: break-word;

      li {
        padding: 8px 5px;

        .listTitle {
          display: inline-block;
          padding-bottom: 5px;
        }
      }

      .textTitle {
        display: block;
        padding: 10px 15px 0;
      }

      .textBody {
        padding: 10px 15px;
        line-height: 25px;

        &.preText {
          white-space: pre-line;
          margin-top: -25px;
        }
      }

      .circleWrap {
        width: 100%;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        padding: 20px 0;

        .circle {
          width: 130px;
          height: 130px;
          border-radius: 100%;
          background-color: #e7efee;
          display: flex;
          align-items: center;
          padding: 10px;
          box-sizing: border-box;
          color: #005246;
          font-weight: bold;
          font-size: 18px;
          word-break: break-word;
        }
      }

      .tableWrap {
        padding: 10px 0;

        .tableTitle {
          padding: 0 0 5px;
        }

        .DocTable {
          border: 1px solid #606266;
          border-collapse: collapse;

          th,
          td {
            width: 50%;
            padding: 5px;
            border: 1px solid #606266;
            border-collapse: collapse;
            text-align: left;
          }
        }
      }

      &.clear {
        padding: 0;
        background-color: transparent;

        .textTitle {
          padding-left: 0;
          padding-right: 0;
        }

        .textBody {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    .replenish {
      font-size: 16px;
      padding: 20px 0 0;
      word-break: break-word;
    }

    .dialog-footer {
      padding-bottom: 10px;
      text-align: center !important;
    }
  }
}
</style>

<style lang="scss">
  #modalDocument {
    .el-dialog {
      .el-dialog__header {
        padding: 0;
      }

      .el-dialog__body {
        padding: 20px;
      }
    }
  }
</style>
